var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinnn03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 332 443",
    style: {
      enableBackground: "new 0 0 332 443"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0BlueBgRechBuild{fill:#FFFFFF;}\n\t.st1BlueBgRechBuild{fill:#010202;}\n\t.st2BlueBgRechBuild{fill:#bee8ff;}\n\t.st3BlueBgRechBuild{opacity:0.129;}\n\t.st4BlueBgRechBuild{fill:none;stroke:#010202;stroke-width:6.5416;stroke-miterlimit:10;}\n\t.st5BlueBgRechBuild{fill:none;stroke:#010202;stroke-width:6.8851;stroke-miterlimit:10;}\n\t.st6BlueBgRechBuild{fill:none;stroke:#010202;stroke-width:6.0779;stroke-miterlimit:10;}\n\t.st7BlueBgRechBuild{fill:none;stroke:#010202;stroke-width:6.6192;stroke-miterlimit:10;}\n\t.st8BlueBgRechBuild{fill:none;stroke:#010202;stroke-width:6.1122;stroke-miterlimit:10;}\n\t.st9BlueBgRechBuild{fill:#FFFFFF;stroke:#010202;stroke-width:6.3794;stroke-miterlimit:10;}\n\t.st1BlueBgRechBuild0{fill:none;stroke:#010202;stroke-width:6.3794;stroke-miterlimit:10;}\n\t.st1BlueBgRechBuild1{fill:none;stroke:#010202;stroke-width:5.9409;stroke-miterlimit:10;}\n\t.st1BlueBgRechBuild2{fill:none;stroke:#010202;stroke-width:6.2218;stroke-miterlimit:10;}\n\t.st1BlueBgRechBuild3{fill:none;stroke:#010202;stroke-width:3.0422;stroke-miterlimit:10;}\n\t.st1BlueBgRechBuild4{fill:none;stroke:#010202;stroke-width:3.2188;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    transform: "translate(499.447 0.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    className: "st0BlueBgRechBuild",
    d: "M-480.65,4.17l-4.53,434.3h299.93l3.53-433.27L-480.65,4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    className: "st1BlueBgRechBuild",
    d: "M-185.25,441.52h-299.93c-0.78,0.01-1.54-0.23-2.17-0.69c-0.54-0.38-0.87-1-0.88-1.67 l4.53-435.74c0-1.29,1.37-2.31,3.07-2.32l298.93,1.02c0.77-0.01,1.53,0.23,2.16,0.69c0.54,0.38,0.87,1,0.88,1.66l-3.53,434.71 C-182.42,440.67-183.77,441.7-185.25,441.52z M-482.11,436.86h293.82L-184.8,6.8l-292.82-1.01L-482.11,436.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    transform: "translate(8.771 12.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    className: "st2BlueBgRechBuild",
    d: "M-374.7,141.36c-18.71-0.12-40.43-0.9-59.14-1.02c0-19.03,0-39.54,0.25-59.41 c19.83-1.03,39.69-1,59.52,0.08C-373.71,100.46-373.94,119.92-374.7,141.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    className: "st1BlueBgRechBuild",
    d: "M-374.71,144.41L-374.71,144.41c-9.39-0.06-19.67-0.29-29.62-0.51 c-9.94-0.22-20.19-0.45-29.53-0.51c-1.68-0.01-3.04-1.38-3.04-3.06v-5.15c0-17.82,0-36.19,0.25-54.3c0.02-1.6,1.28-2.92,2.88-3 c19.93-1.03,39.91-1.01,59.84,0.08c1.6,0.09,2.86,1.39,2.89,2.99c0.36,19,0.16,38.23-0.62,60.51 C-371.7,143.12-373.06,144.42-374.71,144.41z M-430.77,137.31c8.54,0.09,17.7,0.29,26.59,0.49c8.89,0.2,18.04,0.4,26.55,0.49 c0.69-19.82,0.85-37.25,0.57-54.37c-18.55-0.88-36.11-0.91-53.5-0.08c-0.22,17.13-0.21,34.52-0.21,51.35V137.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    transform: "translate(26.83 12.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    className: "st2BlueBgRechBuild",
    d: "M-269.02,141.36c-18.71-0.12-40.43-0.9-59.14-1.02c0-19.03,0-39.54,0.25-59.41 c19.83-1.03,39.69-1,59.52,0.08C-268.03,100.46-268.26,119.92-269.02,141.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    className: "st1BlueBgRechBuild",
    d: "M-269.03,144.41L-269.03,144.41c-9.39-0.06-19.67-0.29-29.62-0.51 c-9.94-0.22-20.19-0.45-29.53-0.51c-1.68-0.01-3.04-1.38-3.04-3.06v-5.26c0-17.76,0-36.13,0.25-54.19c0.03-1.6,1.29-2.92,2.89-3 c19.93-1.03,39.91-1.01,59.84,0.08c1.6,0.09,2.86,1.39,2.89,2.99c0.36,19.03,0.16,38.26-0.62,60.51 C-266.02,143.12-267.38,144.42-269.03,144.41z M-325.12,137.31c8.54,0.09,17.7,0.29,26.59,0.49c8.89,0.2,18.04,0.4,26.55,0.49 c0.69-19.8,0.85-37.23,0.57-54.37c-18.55-0.88-36.11-0.91-53.5-0.08c-0.22,17.13-0.21,34.44-0.21,51.23V137.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    transform: "translate(8.528 26.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    className: "st2BlueBgRechBuild",
    d: "M-376.13,220.94c-18.72-0.12-40.43-0.9-59.14-1.02c0-19.03,0-39.54,0.25-59.41 c19.83-1.03,39.7-1,59.53,0.08C-375.13,180.03-375.37,199.49-376.13,220.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    className: "st1BlueBgRechBuild",
    d: "M-376.13,223.99L-376.13,223.99c-9.4-0.06-19.71-0.29-29.67-0.51 c-9.96-0.22-20.15-0.45-29.46-0.51c-1.68-0.01-3.03-1.37-3.04-3.05v-5.15c0-17.82,0-36.19,0.25-54.3c0.03-1.6,1.29-2.92,2.89-3 c19.93-1.03,39.9-1.01,59.83,0.08c1.6,0.08,2.87,1.39,2.9,2.99c0.36,19,0.16,38.23-0.62,60.51 C-373.11,222.71-374.48,224-376.13,223.99z M-432.22,216.89c8.52,0.09,17.67,0.29,26.53,0.49c8.87,0.2,18.07,0.4,26.61,0.49 c0.69-19.82,0.84-37.25,0.57-54.37c-18.55-0.88-36.11-0.9-53.5-0.08c-0.21,17.13-0.21,34.52-0.21,51.35L-432.22,216.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    transform: "translate(26.587 26.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    className: "st2BlueBgRechBuild",
    d: "M-270.43,220.94c-18.72-0.12-40.43-0.9-59.14-1.02c0-19.03-0.03-39.54,0.25-59.41 c19.83-1.03,39.7-1,59.53,0.08C-269.44,180.03-269.67,199.48-270.43,220.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    className: "st1BlueBgRechBuild",
    d: "M-270.44,223.99L-270.44,223.99c-9.4-0.06-19.71-0.29-29.67-0.51 c-9.96-0.22-20.15-0.45-29.46-0.51c-1.68-0.01-3.03-1.37-3.04-3.05v-5.15c0-17.82,0-36.19,0.25-54.3c0.03-1.6,1.29-2.92,2.89-3 c19.93-1.03,39.9-1.01,59.83,0.08c1.6,0.08,2.87,1.39,2.9,2.99c0.36,19,0.16,38.23-0.62,60.51 C-267.43,222.7-268.79,224-270.44,223.99z M-326.53,216.89c8.52,0.09,17.67,0.29,26.53,0.49c8.87,0.2,18.07,0.4,26.61,0.49 c0.69-19.82,0.84-37.25,0.57-54.37c-18.55-0.88-36.11-0.91-53.5-0.08c-0.21,17.13-0.21,34.52-0.21,51.35V216.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    transform: "translate(8.528 40.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    className: "st2BlueBgRechBuild",
    d: "M-376.13,300.52c-18.72-0.12-40.43-0.9-59.14-1.02c0-19.03,0-39.54,0.25-59.41 c19.83-1.03,39.7-1,59.53,0.08C-375.13,259.61-375.37,279.06-376.13,300.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    className: "st1BlueBgRechBuild",
    d: "M-376.13,303.56L-376.13,303.56c-9.4-0.06-19.71-0.29-29.67-0.51 c-9.96-0.22-20.15-0.45-29.46-0.51c-1.68-0.01-3.03-1.37-3.04-3.05v-5.15c0-17.82,0-36.19,0.25-54.3c0.03-1.6,1.29-2.92,2.89-3 c19.93-1.03,39.9-1.01,59.83,0.08c1.6,0.08,2.87,1.39,2.9,2.99c0.36,19,0.16,38.23-0.62,60.51 C-373.11,302.28-374.48,303.58-376.13,303.56z M-432.22,296.47c8.52,0.09,17.67,0.29,26.53,0.49c8.87,0.2,18.07,0.4,26.61,0.49 c0.69-19.82,0.84-37.25,0.57-54.37c-18.55-0.88-36.11-0.9-53.5-0.08c-0.21,17.13-0.21,34.52-0.21,51.35L-432.22,296.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    transform: "translate(26.587 40.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    className: "st2BlueBgRechBuild",
    d: "M-270.43,300.52c-18.72-0.12-40.43-0.9-59.14-1.02c0-19.03-0.03-39.54,0.25-59.41 c19.82-1.02,39.69-0.99,59.51,0.09C-269.44,259.61-269.67,279.06-270.43,300.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    className: "st1BlueBgRechBuild",
    d: "M-270.44,303.56L-270.44,303.56c-9.4-0.06-19.71-0.29-29.67-0.51 c-9.96-0.22-20.15-0.45-29.46-0.51c-1.68-0.01-3.03-1.37-3.04-3.05v-5.15c0-17.82,0-36.19,0.25-54.3c0.03-1.6,1.29-2.92,2.89-3 c19.93-1.03,39.9-1.01,59.83,0.08c1.6,0.08,2.87,1.39,2.9,2.99c0.36,19,0.16,38.23-0.62,60.51 C-267.43,302.28-268.79,303.58-270.44,303.56z M-326.53,296.47c8.52,0.09,17.67,0.29,26.53,0.49c8.87,0.2,18.07,0.4,26.61,0.49 c0.69-19.82,0.84-37.25,0.57-54.37c-18.55-0.88-36.11-0.91-53.5-0.08c-0.21,17.13-0.21,34.52-0.21,51.35V296.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    transform: "translate(0.625 4.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    className: "st1BlueBgRechBuild",
    d: "M-184.56,35.56h-0.1c-99.85-3.37-199.7-3.94-296.75-1.69c-1.69,0.04-3.09-1.3-3.12-2.99 c0,0,0,0,0,0c-0.03-1.69,1.3-3.08,2.99-3.12c97.16-2.25,197.13-1.69,297.09,1.69c1.69,0.06,3,1.47,2.95,3.16 C-181.57,34.26-182.92,35.57-184.56,35.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    transform: "translate(9.266 16.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    className: "st1BlueBgRechBuild",
    d: "M-376.88,97.63h-0.29l-55.86-0.53c-0.56,0-1.01-0.46-1.01-1.02c0,0,0,0,0-0.01 c-0.01-0.55,0.43-1,0.98-1.01c0.02,0,0.03,0,0.05,0l56.11,0.56c0.56,0,1.01,0.46,1.01,1.02c0,0,0,0,0,0.01 C-375.91,97.19-376.34,97.62-376.88,97.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    transform: "translate(27.107 16.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    className: "st1BlueBgRechBuild",
    d: "M-269.12,97.62h-0.05c-13.46-0.76-29.6-0.69-45.22-0.59c-4.8,0-9.59,0.05-14.19,0.05 c-0.56,0-1.02-0.45-1.02-1.01c0,0,0-0.01,0-0.01c0-0.56,0.45-1.01,1.01-1.01c0,0,0,0,0.01,0c4.6,0,9.36,0,14.18-0.05 c15.64-0.08,31.81-0.17,45.33,0.6c0.56,0.03,0.99,0.51,0.96,1.07c0,0,0,0,0,0C-268.16,97.2-268.59,97.62-269.12,97.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    transform: "translate(9.139 29.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    className: "st1BlueBgRechBuild",
    d: "M-378.46,178.85h-0.03c-8.09-0.31-17.77-0.21-27.12-0.11c-9.59,0.1-19.57,0.21-28.14-0.12 c-0.56-0.02-1-0.49-0.98-1.05c0,0,0,0,0,0c0.03-0.56,0.5-0.99,1.06-0.98c8.52,0.33,18.45,0.22,28.04,0.12 c9.38-0.1,19.08-0.2,27.23,0.11c0.56,0.02,1,0.49,0.98,1.05c0,0,0,0.01,0,0.01C-377.46,178.42-377.92,178.85-378.46,178.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    transform: "translate(27.107 29.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    className: "st1BlueBgRechBuild",
    d: "M-271.45,178.8h-0.04c-13.35-0.56-34.14-0.78-57.07-0.62l0,0c-0.56,0-1.01-0.45-1.02-1.01 c-0.01-0.56,0.44-1.02,1-1.03c0,0,0.01,0,0.01,0c22.95-0.16,43.79,0.05,57.17,0.62c0.56,0.02,1,0.49,0.97,1.05c0,0,0,0.01,0,0.01 C-270.46,178.38-270.91,178.81-271.45,178.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    transform: "translate(8.88 44.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    className: "st1BlueBgRechBuild",
    d: "M-403.85,261.27c-10.62,0-21.24-0.09-31.44-0.47c-0.56-0.03-1-0.5-0.98-1.06 c0.05-0.55,0.51-0.97,1.06-0.98c14.16,0.55,29.31,0.49,43.97,0.45c4.21,0,8.39,0,12.55,0c0.56,0,1.02,0.45,1.02,1.01 c0,0.56-0.46,1.02-1.02,1.02c-4.16,0-8.34,0-12.55,0C-395.4,261.26-399.63,261.27-403.85,261.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    transform: "translate(27.065 43.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    className: "st1BlueBgRechBuild",
    d: "M-328.83,260.67c-0.55,0-1-0.44-1.01-0.99c-0.02-0.56,0.43-1.03,0.99-1.04c0,0,0.01,0,0.01,0 c19.06-0.43,38.37-0.56,57.45-0.34c0.56,0.01,1.01,0.47,1.01,1.03c-0.01,0.56-0.46,1.01-1.02,1.01l0,0 c-19.04-0.21-38.37-0.09-57.38,0.35L-328.83,260.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    transform: "translate(3.493 6.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    className: "st1BlueBgRechBuild",
    d: "M-466.77,85.13L-466.77,85.13c-0.57,0-1.02-0.46-1.02-1.03l0.14-41.95 c0-0.56,0.46-1.02,1.02-1.02l0,0c0.56,0.01,1.01,0.47,1.01,1.03l-0.14,41.96C-465.76,84.67-466.21,85.12-466.77,85.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    transform: "translate(5.52 6.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    className: "st1BlueBgRechBuild",
    d: "M-454.25,61.56c-0.55,0-1-0.43-1.02-0.98l-0.69-17.82c-0.02-0.56,0.42-1.03,0.98-1.06 c0.56-0.02,1.03,0.42,1.06,0.98l0.69,17.82c0.02,0.56-0.41,1.03-0.97,1.05c0,0-0.01,0-0.01,0H-454.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    transform: "translate(41.915 7.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    className: "st1BlueBgRechBuild",
    d: "M-241.91,95.46h-0.08c-0.56-0.04-0.98-0.53-0.94-1.1c1.25-16.71,1.82-33.69,1.65-50.46 c-0.01-0.56,0.44-1.03,1.01-1.03l0,0l0,0c0.56,0,1.01,0.45,1.02,1.01c0.16,16.84-0.39,33.87-1.65,50.64 C-240.94,95.05-241.38,95.46-241.91,95.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    transform: "translate(39.885 7.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    className: "st1BlueBgRechBuild",
    d: "M-253.13,65.19c-0.55,0-1-0.43-1.02-0.98l-0.69-17.82c-0.02-0.56,0.42-1.03,0.98-1.06 c0.56-0.01,1.02,0.42,1.05,0.98l0.69,17.82c0.02,0.56-0.41,1.03-0.97,1.06H-253.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    transform: "translate(8.054 6.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    className: "st1BlueBgRechBuild",
    d: "M-439.08,54.18c-0.52,0-0.96-0.4-1.01-0.92l-1.03-10.79c-0.05-0.56,0.36-1.06,0.92-1.11 c0.56-0.04,1.05,0.36,1.11,0.92l1.03,10.79c0.05,0.56-0.36,1.06-0.92,1.11H-439.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    transform: "translate(0.636 4.527)",
    className: "st3BlueBgRechBuild"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    className: "st1BlueBgRechBuild",
    d: "M-188.54,31.49c-2.32,0.14-4.65,0.06-6.96,0c-8.33,0.3-16.62-0.16-24.94-0.37 c-20.71-1.08-65.83-2.24-94.82-1.37c-22.46-1.08-44.94-1.17-67.4-2.06c-18.13-0.19-36.27,0.51-54.41,0.73 c-13.03-0.29-26.07,0.14-39.06,1.29c-5.12,0.52-8.85,5.1-8.33,10.22c0.45,4.4,3.93,7.88,8.33,8.33 c16.73-1.62,33.54-2.21,50.34-1.75c27.96-0.19,55.92,0.21,83.88,0.47c29.37,1.02,58.74,1.03,88.11,1.12 c8.22,0.28,16.45,1.21,24.67,0.92c5.85-0.23,11.71-0.16,17.56,0.21c7.36,0.53,14.74,0.45,22.08-0.25l-2.15,0.32 c4.94,1.11,9.84-2,10.95-6.95c0.14-0.64,0.22-1.3,0.22-1.96C-180.3,35.71-183.88,31.76-188.54,31.49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinnn03);
export default __webpack_public_path__ + "static/media/drinnn-03.097e8dfe9b4c728513bc0f5aa76f7e1a.svg";
export { ForwardRef as ReactComponent };